import React, { useEffect, useRef, useState } from "react";
import { useChartContext } from "../../../Context/ChartsContext";
import {
  downloadImage,
  getDayDiffBetweenFiscalMonths,
  getFinancialYearMonthsPassed,
  months,
} from "../../../Utilitie";
import "../../PunctualityFolder/table.css";
import SingleTypeLineChart from "../../../CHARTS/SingleTypeLineChart";
import DownloadAsImage from "../../../Extra/DownloadAsImage";
import { IoIosArrowDropdown, IoIosArrowDropdownCircle } from "react-icons/io";
const TYLoadingData = ({ defCode }) => {
  const [yearDif, setYearDif] = useState(5);
  const [openStates, setOpenStates] = useState({ selectMonth: false });
  const [selectedMonthSet, setSelectedMonthSet] = useState(new Set());
  const [viewMonth, setViewMonth] = useState(months);
  const [cMonthsData, setCMonthsData] = useState(months);
  const [btnClick, setBtnClick] = useState(true);
  const [tableData, setTableData] = useState(null);
  const [colData, setColData] = useState([]);
  const [code, setCode] = useState(defCode);
  const [activeGraph, setActiveGraph] = useState("TOTAL");
  const storingChartData = [];
  const { bestSheetDataObj } = useChartContext();
  const reportRef = useRef(null);

  const handleYearChange = (e) => {
    setYearDif(e.target.value);
  };
  const handleColChange = (e) => {
    setCode(e.target.value);
  };
  const avgColData = [
    "DWB",
    "SPEED",
    "DSL_LM",
    "AC_KM",
    "TOTAL_KM",
    "SPEED_INCLU_STB",
    "PUN_MAIL",
    "PUN_MEXp",
    "WTR",
  ];
  const removeMsg = ["DWB", "SPEED", "SPEED_INCLU_STB"];
  const avgDayWise = ["TOTAL_RKS", "DESP_RKS", "RECEIPT_RKS"];
  useEffect(() => {
    let exclude = ["ID", "F_YEAR", "C_YEAR", "A_MONTH", "F_MONTH", "C_MONTH"];
    if (bestSheetDataObj.bestSheetData) {
      const keys = Object.entries(
        bestSheetDataObj.bestSheetData[0].months[0].data
      )
        .filter(([key]) => !exclude.includes(key)) // remove "ID"
        .map(([key]) => key); // extract keys

      setColData(keys);
    }
    const cMonths = [];
    if (bestSheetDataObj?.bestSheetData) {
      bestSheetDataObj?.bestSheetData[0]?.months.map((month) => [
        cMonths.push(month.A_MONTH.toUpperCase()),
      ]);
    }
    setCMonthsData(cMonths);
  }, [bestSheetDataObj]);

  const handleBTN = () => {
    if (btnClick) {
      const cMonths = [];
      bestSheetDataObj?.bestSheetData[0]?.months.map((month) => [
        cMonths.push(month.A_MONTH.toUpperCase()),
      ]);
      setViewMonth(cMonths);
      setCMonthsData(cMonths);
    } else {
      setViewMonth(months);
    }
    setBtnClick(!btnClick);
  };

  const filterData = bestSheetDataObj?.bestSheetData?.filter((fyObj) => {
    const currentYear = fyObj?.F_YEAR?.substring(0, 4);
    const baseYear = bestSheetDataObj?.bestSheetData[0]?.F_YEAR?.substring(
      0,
      4
    );
    return currentYear > (parseInt(baseYear) - yearDif).toString();
  });

  useEffect(() => {
    const sortedData = filterData
      ?.slice()
      ?.sort(
        (a, b) => Number(a?.F_YEAR.slice(0, 4)) - Number(b?.F_YEAR.slice(0, 4))
      );
    setTableData(sortedData);
  }, [bestSheetDataObj, yearDif]);

  const toggleSelection = (setFunc, selectedSet, item) => {
    const newSet = new Set(selectedSet);
    if (newSet.has(item)) {
      newSet.delete(item);
    } else {
      newSet.add(item);
    }
    setFunc(newSet);
  };
  const monthPassed = getFinancialYearMonthsPassed();

  useEffect(() => {
    if (monthPassed) {
      const upperCaseArr = Array.from(monthPassed).map((str) =>
        str.toUpperCase().slice(0, 3)
      );
      setSelectedMonthSet(new Set(upperCaseArr));
    }
  }, []);
  useEffect(() => {
    const setData = Array.from(selectedMonthSet);
    setViewMonth(setData);
  }, [selectedMonthSet]);
  const toggleDropdown = (key) => {
    setOpenStates((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  // /////////////////////////////////////////////////////
  return (
    <div className="">
      <div ref={reportRef}>
        <div className="d-flex align-items-center justify-content-around bg-dark text-white p-1">
          <div style={{ fontSize: "12px" }}>
            <select onChange={handleColChange} value={code}>
              <option>select an option</option>
              {colData.map((col, ind) => {
                return (
                  <option value={col} key={ind}>
                    {col?.replace("_", " ")?.replace("_", " ")}
                  </option>
                );
              })}
            </select>
            <h6 style={{ fontSize: "15px" }}>{yearDif} year data</h6>
          </div>
          <div style={{ fontSize: "12px" }}>
            select last years range
            <br />
            <input
              className="d-flex align-items-center"
              onChange={handleYearChange}
              value={yearDif}
              type="range"
              min={1}
              max={bestSheetDataObj?.bestSheetData?.length}
            />
          </div>
          <div className="   ">
            {/* /////////////////////////////////// */}
            <div>
              <div
                style={{
                  position: "relative",
                  fontSize: 12,
                  borderRadius: "5px",
                }}
              >
                <div
                  className=""
                  onClick={() => toggleDropdown("selectMonth")}
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    cursor: "pointer",
                    minWidth: "150px",
                    maxHeight: "50px",
                    overflow: "hidden",
                    userSelect: "none",
                  }}
                >
                  Select months &nbsp;
                  <IoIosArrowDropdownCircle
                    style={{
                      fontSize: 15,
                      transition: "transform 0.3s ease",
                      transform: openStates.selectMonth
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  />
                </div>

                {openStates.selectMonth && (
                  <div
                    className="newUiBody"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "#fff",
                      border: "1px solid #ccc",
                      // background: "#fff",
                      zIndex: 10,
                    }}
                  >
                    <hr className="m-0 p-0" />
                    <div
                      className="row suggestion mt-1"
                      style={{
                        maxHeight: "250px",
                        minHeight: "50px",
                        overflowY: "auto",
                        color: "black",
                      }}
                    >
                      {months.length > 0 ? (
                        months.map((month, index) => (
                          <div
                            key={index}
                            className="col-md fade-in"
                            style={{ fontSize: "12px" }}
                          >
                            <label
                              className=" text-start"
                              style={{ display: "block", cursor: "pointer" }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={selectedMonthSet.has(month)}
                                onChange={() =>
                                  toggleSelection(
                                    setSelectedMonthSet,
                                    selectedMonthSet,
                                    month
                                  )
                                }
                              />
                              &nbsp;{month}
                            </label>
                          </div>
                        ))
                      ) : (
                        <div className="col-md-12 text-center">
                          No items found
                        </div>
                      )}
                    </div>
                    <hr className="m-0 p-0" />
                    <div className="d-flex justify-content-evenly mt-1">
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => setSelectedMonthSet(new Set(months))}
                      >
                        Select All
                      </button>
                      <button
                        className="btn btn-sm btn-outline-success"
                        onClick={() => setSelectedMonthSet(new Set())}
                      >
                        Clear All
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* /////////////////////////////////////////// */}
          </div>
          <DownloadAsImage reportRef={reportRef} title={code} />
        </div>

        <div className="table-responsive">
          <table
            className="table newUiTable table-striped-columns table-hover m-0 p-0"
            style={{
              fontSize: "12px",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <thead className="table-dark">
              <tr>
                <th className="sticky-col first-col">Sn</th>
                <th className="sticky-col first-col">Months</th>
                {tableData &&
                  tableData.map((fObj, ind) => {
                    return <th>{fObj.F_YEAR.replace("_", "-")}</th>;
                  })}
              </tr>
            </thead>
            <tbody>
              {viewMonth &&
                viewMonth.map((month, index) => (
                  <tr key={index}>
                    <td className="sticky-col first-col">{index + 1}</td>
                    <td className="sticky-col first-col">{month}</td>

                    {tableData &&
                      tableData.map((fObj, fIndex) => {
                        const matchMonth = fObj.months.find(
                          (mObj) => month === mObj?.A_MONTH?.toUpperCase()
                        );

                        return (
                          <td key={`${index}-${fIndex}`}>
                            {matchMonth ? matchMonth.data[code] : "-"}
                          </td>
                        );
                      })}
                  </tr>
                ))}

              <>
                {/* TOTAL ROW */}
                <tr
                  style={{ cursor: "pointer" }}
                  className="table-dark fw-bold"
                  onClick={() => setActiveGraph("TOTAL")}
                >
                  <td colSpan={2} className="sticky-col first-col">
                    TOTAL
                  </td>

                  {tableData &&
                    tableData.map((fObj) => {
                      const availableMonths = viewMonth
                        .map((m) => m.toUpperCase())
                        .filter((month) =>
                          fObj.months.some(
                            (mObj) => mObj?.A_MONTH?.toUpperCase() === month
                          )
                        );

                      const total = availableMonths.reduce((sum, month) => {
                        const matchMonth = fObj.months.find(
                          (mObj) => mObj?.A_MONTH?.toUpperCase() === month
                        );
                        return (
                          sum + (matchMonth ? Number(matchMonth.data[code]) : 0)
                        );
                      }, 0);

                      const totalValue = Number(total.toFixed(2));

                      storingChartData.push({
                        time: fObj.F_YEAR.replace("_", "-"),
                        [code + "_TOTAL"]: totalValue,
                      });

                      return <td key={`total-${fObj.F_YEAR}`}>{totalValue}</td>;
                    })}
                </tr>

                {/* AVERAGE ROW */}
                <tr
                  className="table-dark fw-bold"
                  style={{ cursor: "pointer" }}
                  onClick={() => setActiveGraph("AVG")}
                >
                  <td colSpan={2} className="sticky-col first-col">
                    AVERAGE
                  </td>

                  {tableData &&
                    tableData.map((fObj) => {
                      const availableMonths = viewMonth
                        .map((m) => m.toUpperCase())
                        .filter((month) =>
                          fObj.months.some(
                            (mObj) => mObj?.A_MONTH?.toUpperCase() === month
                          )
                        );

                      const total = availableMonths.reduce((sum, month) => {
                        const matchMonth = fObj.months.find(
                          (mObj) => mObj?.A_MONTH?.toUpperCase() === month
                        );
                        return (
                          sum + (matchMonth ? Number(matchMonth.data[code]) : 0)
                        );
                      }, 0);

                      const monthsCount = availableMonths.length || 1;
                      const totalDays =
                        availableMonths.length > 0
                          ? getDayDiffBetweenFiscalMonths(
                              fObj.F_YEAR,
                              availableMonths[0],
                              availableMonths[availableMonths.length - 1]
                            )
                          : 0;

                      const avgValue = avgDayWise.includes(code)
                        ? Number((total / totalDays).toFixed(2))
                        : Number((total / monthsCount).toFixed(2));

                      storingChartData.push({
                        time: fObj.F_YEAR.replace("_", "-"),
                        [code + "_AVG"]: avgValue,
                      });

                      return <td key={`avg-${fObj.F_YEAR}`}>{avgValue}</td>;
                    })}
                </tr>
              </>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-1">
        Graph For {activeGraph}
        <SingleTypeLineChart
          data={storingChartData.filter((d) => d[code + "_" + activeGraph])}
          title={code}
          singleValue={true}
        />
      </div>
    </div>
  );
};
export default TYLoadingData;
